import type { Mode, Politician } from './types';

// PostHog survey "Nahlás chybu" (type api) in the Politikdle.sk project. The
// game renders the form itself; these ids tie each answer to its question so
// reports show up in PostHog's survey results.
export const REPORT_SURVEY = {
  id: '01a10bbb-e978-0000-dc89-b1d8badab450',
  politician: { id: 'dc8de297-e982-42b4-8d55-153b0f44f64f', question: 'O ktorého politika ide?' },
  category: { id: '9d2cf9ee-1632-4689-8e9b-7eb3142549ac', question: 'Čo nesedí?' },
  text: { id: 'ee6753fa-f3ce-400b-b340-bdee84061514', question: 'Popíš chybu' },
} as const;

/** Must match the survey's choices exactly. */
export const REPORT_CATEGORIES = [
  'Strana',
  'Orientácia',
  'Najvyššia funkcia',
  'Dnes',
  'Kraj narodenia',
  'Rok narodenia',
  'Fotka',
  'Meno',
  'Chyba v hre',
  'Iné',
] as const;

export interface Report {
  politician: Politician | null;
  category: (typeof REPORT_CATEGORIES)[number];
  text: string;
  mode: Mode;
  day: number;
  practice: boolean;
}

/** Properties of the `survey sent` event for one report. */
export function reportEvent(r: Report): Record<string, unknown> {
  const answers = [
    [REPORT_SURVEY.politician, r.politician?.name ?? null],
    [REPORT_SURVEY.category, r.category],
    [REPORT_SURVEY.text, r.text],
  ] as const;
  return {
    $survey_id: REPORT_SURVEY.id,
    $survey_completed: true,
    $survey_questions: answers.map(([q, response]) => ({ id: q.id, question: q.question, response })),
    ...Object.fromEntries(answers.map(([q, response]) => [`$survey_response_${q.id}`, response])),
    report_politician_id: r.politician?.id ?? null,
    report_mode: r.mode,
    report_day: r.day,
    report_practice: r.practice,
  };
}
